/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import {
  READ_PERFORMANCE_REPORT,
  PERFORMANCE_REPORTS_PATH,
} from 'domain/people/performanceReport/usePerformanceReportService';
import PerformanceReportList from 'domain/people/performanceReport/List';
import { createRoute, Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';

const usePerformanceReportRoute = () => createRoute({ listRoute: PERFORMANCE_REPORTS_PATH });

const PerformanceReportRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = usePerformanceReportRoute();

  return (
    <ProtectedRouter basePath={PERFORMANCE_REPORTS_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_PERFORMANCE_REPORT}>
              <PerformanceReportList />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

PerformanceReportRouter.getRouterPath = () => PERFORMANCE_REPORTS_PATH;

export default PerformanceReportRouter;
